import { formatUsd, SYMBOLS } from "../../config/trading";

export function StrategyFormSection({ bot, botBusy, onToggleBot, risk, setRisk, onSaveRisk }) {
  return (
    <>
      <div className="panel-head">
        <span className="label">GRID ENGINE</span>
        <button data-testid="bot-toggle-button" className={bot.enabled ? "danger-button" : "primary-button"} onClick={onToggleBot} disabled={botBusy}>
          {bot.enabled ? "Stop" : "Start"}
        </button>
      </div>
      <div className="range-box" data-testid="bot-grid-range">
        <span>LOW <b className="mono">{formatUsd(bot.grid_low)}</b></span>
        <span>HIGH <b className="mono">{formatUsd(bot.grid_high)}</b></span>
      </div>
      <label className="field-label" htmlFor="max-trade-input">Max trade USDT</label>
      <input
        id="max-trade-input"
        data-testid="risk-max-trade-input"
        className="terminal-input"
        type="number"
        value={risk.max_trade_usdt}
        onChange={(event) => setRisk((current) => ({ ...current, max_trade_usdt: event.target.value }))}
      />
      <label className="field-label" htmlFor="daily-loss-input">Daily loss stop</label>
      <input
        id="daily-loss-input"
        data-testid="risk-daily-loss-input"
        className="terminal-input"
        type="number"
        value={risk.daily_loss_limit_usdt}
        onChange={(event) => setRisk((current) => ({ ...current, daily_loss_limit_usdt: event.target.value }))}
      />
      <button data-testid="risk-save-button" className="secondary-button" onClick={() => onSaveRisk(SYMBOLS)}>Save Risk</button>
    </>
  );
}